/* @flow */

import React from 'react';
import { Modal, Icon, Header, Button, Message } from 'semantic-ui-react';

type Props = {
  open: boolean,
  loading: boolean,
  onConfirm: () => void,
  onClose: () => void,
};

const getConfirmMessage = () => {
  return (
    <Message icon>
      <Icon name="circle info" />
      <Message.Content>
        <Message.Header>
          {`Vous êtes sur le point de modifier le layout de la page`}
        </Message.Header>
        <p>
          {`
          Les redimensionnements effectués sur les images seront perdus et
          seront remplacés par les images originales.
          `}
        </p>
        <p>{`Êtes-vous sûr(e) de vouloir modifier le layout ?`}</p>
      </Message.Content>
    </Message>
  );
};

const ConfirmLayoutChange = ({ open, loading, onConfirm, onClose }: Props) => {
  return (
    <Modal open={open} onClose={onClose} closeIcon size="small">
      <Header content={`Modification de layout`} />
      <Modal.Content>
        {getConfirmMessage()}
      </Modal.Content>
      <Modal.Actions>
        <Button
          onClick={onClose}
          labelPosition="left"
          icon="close"
          content="Annuler"
        />
        <Button
          onClick={onConfirm}
          loading={loading}
          positive
          labelPosition="right"
          icon="check"
          content="Confirmer"
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmLayoutChange;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/ConfirmLayoutChange.js